import { FragmentMessages } from "../../common/fragment-messages";
import FragmentDataType from "../enums/fragment-data-type";
import RougeYardlineDefaultValue from "./default-value/rouge-yardline-default-value";
import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

export default class SkipKickoff extends Fragment {
    constructor(fieldPosition) {
        super();
        this.fieldPosition = fieldPosition;

        this.requiredData = [
            {
                name: "fieldPosition",
                type: FragmentDataType.FieldPosition,
                displayName: "Spot",
                title: (team) => `${team.teamName} Spot`,
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                appliesToOpponent: () => true,
                defaultValue: ({ play, summaryContext }) => {
                    const value = new RougeYardlineDefaultValue(
                        play,
                        this,
                        summaryContext
                    ).resolve();

                    return value;
                }
            }
        ];
    }

    summarize() {
        return new FragmentSummary("");
    }
}
